export default __webpack_public_path__ + "78fed031949dfa78bf41e0d008bac671.png";